
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'Divider',
})
export default class Divider extends Vue {
    @Prop({
        type: String,
        required: false,
    })
    private text: string;
}
